export const siteUrl = "https://imautotech.sk";
export const siteName = "IM Autotech";
export const socialImage = "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=2200&q=85";

export type SeoPage = {
  path: string;
  title: string;
  description: string;
  primaryKeyword: string;
  secondaryKeywords: readonly string[];
  serviceName?: string;
};

type JsonPrimitive = string | number | boolean | null;
type JsonValue = JsonPrimitive | JsonObject | readonly JsonValue[];
type JsonObject = { readonly [key: string]: JsonValue };
type StructuredData = {
  readonly "@context": "https://schema.org";
  readonly "@graph": readonly JsonObject[];
};

export const seoPages: readonly SeoPage[] = [
  {
    path: "/",
    title: "Diagnostika a opravy áut v Trnave | IM Autotech",
    description: "IM Autotech je autoservis v Trnave pre diagnostiku, pravidelný servis, pneuservis, brzdy, podvozok, DPF, EGR a AdBlue. Zavolajte a dohodnite si termín.",
    primaryKeyword: "autoservis Trnava",
    secondaryKeywords: ["autoservis v Trnave", "oprava auta Trnava", "automechanik Trnava"],
  },
  {
    path: "/sluzby/",
    title: "Servis a opravy áut v Trnave | IM Autotech",
    description: "Diagnostika auta, výmena oleja, pneuservis, oprava bŕzd a podvozku aj riešenie problémov DPF, EGR a AdBlue v Trnave. Vyberte službu a objednajte sa.",
    primaryKeyword: "služby autoservisu Trnava",
    secondaryKeywords: ["servis auta Trnava", "opravy áut Trnava"],
  },
  {
    path: "/sluzby/diagnostika/",
    title: "Autodiagnostika Trnava | IM Autotech",
    description: "Autodiagnostika v Trnave: chybové kódy, živé dáta a elektronické systémy. Nájdeme príčinu poruchy a odporučíme ďalší postup. Objednajte sa.",
    primaryKeyword: "autodiagnostika Trnava",
    secondaryKeywords: ["diagnostika auta Trnava", "počítačová diagnostika auta Trnava"],
    serviceName: "Autodiagnostika",
  },
  {
    path: "/sluzby/pravidelny-servis/",
    title: "Výmena oleja a pravidelný servis Trnava | IM Autotech",
    description: "Výmena oleja, filtrov a prevádzkových kvapalín v Trnave. Pravidelný servis prispôsobíme vozidlu, veku aj spôsobu jazdy. Dohodnite si termín.",
    primaryKeyword: "výmena oleja Trnava",
    secondaryKeywords: ["pravidelný servis auta Trnava", "výmena filtrov Trnava"],
    serviceName: "Výmena oleja a pravidelný servis",
  },
  {
    path: "/sluzby/brzdy-a-podvozok/",
    title: "Oprava bŕzd a podvozku Trnava | IM Autotech",
    description: "Servis bŕzd a podvozku v Trnave: kotúče, platničky, tlmiče, ramená, čapy aj uloženia. Preveríme stav a navrhneme poradie opráv.",
    primaryKeyword: "oprava bŕzd Trnava",
    secondaryKeywords: ["servis bŕzd Trnava", "oprava podvozku Trnava"],
    serviceName: "Oprava bŕzd a podvozku",
  },
  {
    path: "/sluzby/diagnostika-oprava-egr/",
    title: "Diagnostika a oprava EGR Trnava | IM Autotech",
    description: "Diagnostika EGR v Trnave vrátane chybových kódov, snímačov a živých dát. Zistíme príčinu problému a odporučíme vhodný postup opravy.",
    primaryKeyword: "oprava EGR Trnava",
    secondaryKeywords: ["diagnostika EGR Trnava", "servis EGR Trnava"],
    serviceName: "Diagnostika a oprava systému EGR",
  },
  {
    path: "/sluzby/diagnostika-servis-dpf/",
    title: "Diagnostika a servis DPF Trnava | IM Autotech",
    description: "Diagnostika DPF v Trnave: zanesenie filtra, diferenčný tlak, regenerácia a súvisiace snímače. Vyhodnotíme stav a odporučíme vhodný servis.",
    primaryKeyword: "diagnostika DPF Trnava",
    secondaryKeywords: ["servis DPF Trnava", "regenerácia DPF Trnava"],
    serviceName: "Diagnostika a servis systému DPF",
  },
  {
    path: "/sluzby/diagnostika-oprava-adblue/",
    title: "Diagnostika a oprava AdBlue Trnava | IM Autotech",
    description: "Diagnostika systému SCR a AdBlue v Trnave. Skontrolujeme čerpadlo, vstrekovanie, snímače a chybové hlásenia a navrhneme vhodnú opravu.",
    primaryKeyword: "oprava AdBlue Trnava",
    secondaryKeywords: ["diagnostika AdBlue Trnava", "oprava SCR Trnava"],
    serviceName: "Diagnostika a oprava systému SCR a AdBlue",
  },
  {
    path: "/sluzby/diagnostika-emisnych-systemov/",
    title: "Diagnostika emisných systémov Trnava | IM Autotech",
    description: "Diagnostika emisných systémov v Trnave. Preveríme údaje, chybové hlásenia a súvislosti medzi DPF, EGR a SCR a navrhneme ďalší postup.",
    primaryKeyword: "diagnostika emisných systémov Trnava",
    secondaryKeywords: ["oprava emisného systému Trnava", "diagnostika DPF EGR SCR Trnava"],
    serviceName: "Diagnostika emisných systémov",
  },
  {
    path: "/sluzby/pneuservis/",
    title: "Pneuservis Trnava | IM Autotech",
    description: "Pneuservis v Trnave: prezutie pneumatík, vyváženie kolies a kontrola dezénu, tlaku aj viditeľného poškodenia. Dohodnite si termín vopred.",
    primaryKeyword: "pneuservis Trnava",
    secondaryKeywords: ["prezutie pneumatík Trnava", "vyváženie kolies Trnava"],
    serviceName: "Pneuservis",
  },
  {
    path: "/sluzby/konzultacia/",
    title: "Konzultácia poruchy vozidla Trnava | IM Autotech",
    description: "Neviete, čo sa deje s autom? V Trnave prejdeme príznaky a históriu vozidla, odporučíme vhodnú diagnostiku a dohodneme ďalší postup.",
    primaryKeyword: "diagnostika poruchy auta Trnava",
    secondaryKeywords: ["konzultácia poruchy vozidla Trnava", "kontrola auta Trnava"],
    serviceName: "Konzultácia poruchy vozidla",
  },
  {
    path: "/o-nas/",
    title: "O autoservise | IM Autotech",
    description: "Spoznajte autoservis IM Autotech v Trnave. Najprv presne diagnostikujeme príčinu, vysvetlíme možnosti a až potom sa dohodneme na oprave.",
    primaryKeyword: "IM Autotech Trnava",
    secondaryKeywords: ["autoservis s diagnostikou Trnava", "automechanik Trnava"],
  },
  {
    path: "/kontakt/",
    title: "Kontakt a objednanie | IM Autotech",
    description: "Objednajte sa do autoservisu IM Autotech na Coburgovej ulici v Trnave. Zavolajte, napíšte alebo pošlite popis problému s vaším vozidlom.",
    primaryKeyword: "autoservis Trnava kontakt",
    secondaryKeywords: ["objednanie do autoservisu Trnava", "autoservis Coburgova Trnava"],
  },
  {
    path: "/ochrana-osobnych-udajov/",
    title: "Ochrana osobných údajov | IM Autotech",
    description: "Informácie o spracovaní osobných údajov pri kontakte s autoservisom IM Autotech v Trnave.",
    primaryKeyword: "ochrana osobných údajov autoservis",
    secondaryKeywords: [],
  },
  {
    path: "/cookies/",
    title: "Cookies | IM Autotech",
    description: "Informácie o používaní cookies na webovej stránke autoservisu IM Autotech.",
    primaryKeyword: "cookies IM Autotech",
    secondaryKeywords: ["zásady cookies", "cookies autoservis"],
  },
] as const;

const businessId = `${siteUrl}/#autoservis`;
const organizationId = `${siteUrl}/#organization`;
const websiteId = `${siteUrl}/#web`;

function normalizePath(pathname: string): string {
  const cleanPath = pathname.split(/[?#]/, 1)[0]?.replace(/\/+/g, "/") || "/";
  if (cleanPath === "/") return "/";
  return `/${cleanPath.replace(/^\/|\/$/g, "")}/`;
}

export function getSeoPage(pathname: string): SeoPage | undefined {
  const normalizedPath = normalizePath(pathname);
  return seoPages.find((page) => page.path === normalizedPath);
}

export function canonicalUrl(page: SeoPage): string {
  return page.path === "/" ? `${siteUrl}/` : `${siteUrl}${page.path}`;
}

export function structuredData(page: SeoPage): StructuredData {
  const pageUrl = canonicalUrl(page);
  const localBusiness = {
    "@type": "AutoRepair",
    "@id": businessId,
    name: siteName,
    legalName: "IM autotech s. r. o.",
    url: `${siteUrl}/`,
    image: socialImage,
    logo: `${siteUrl}/imautotech-blue-logo.svg`,
    telephone: "+421949220152",
    email: "info@imautotech.sk",
    priceRange: "€€",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Coburgova 2263/84",
      addressLocality: "Trnava",
      addressRegion: "Trnavský kraj",
      postalCode: "917 02",
      addressCountry: "SK",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 48.3619436,
      longitude: 17.5724055,
    },
    hasMap: "https://maps.app.goo.gl/k6JvXCn5b1G5m52y7",
    areaServed: {
      "@type": "City",
      name: "Trnava",
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "08:00",
      closes: "17:00",
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "+421949220152",
        email: "info@imautotech.sk",
        contactType: "objednávky a servis",
        availableLanguage: "Slovak",
      },
      {
        "@type": "ContactPoint",
        telephone: "+421918414898",
        email: "info@imautotech.sk",
        contactType: "objednávky a servis",
        availableLanguage: "Slovak",
      },
    ],
  };

  const graph: JsonObject[] = [
    {
      "@type": "Organization",
      "@id": organizationId,
      name: siteName,
      alternateName: "IM Autotech Trnava",
      legalName: "IM autotech s. r. o.",
      description: "Autoservis v Trnave zameraný na diagnostiku, údržbu a opravy vozidiel.",
      url: `${siteUrl}/`,
      logo: `${siteUrl}/imautotech-blue-logo.svg`,
      email: "info@imautotech.sk",
      telephone: "+421949220152",
      address: localBusiness.address,
      contactPoint: localBusiness.contactPoint,
    },
    localBusiness,
    {
      "@type": "WebSite",
      "@id": websiteId,
      url: `${siteUrl}/`,
      name: siteName,
      inLanguage: "sk-SK",
      publisher: { "@id": organizationId },
    },
    {
      "@type": page.path === "/kontakt/" ? "ContactPage" : page.path === "/o-nas/" ? "AboutPage" : "WebPage",
      "@id": `${pageUrl}#webpage`,
      url: pageUrl,
      name: page.title,
      description: page.description,
      inLanguage: "sk-SK",
      isPartOf: { "@id": websiteId },
      about: { "@id": businessId },
    },
  ];

  if (page.serviceName) {
    graph.push({
      "@type": "Service",
      "@id": `${pageUrl}#service`,
      name: page.serviceName,
      url: pageUrl,
      serviceType: page.serviceName,
      provider: { "@id": businessId },
      areaServed: {
        "@type": "City",
        name: "Trnava",
      },
    });
  }

  return {
    "@context": "https://schema.org",
    "@graph": graph,
  };
}

function escapeHtml(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll('"', "&quot;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");
}

function safeJson(value: StructuredData): string {
  return JSON.stringify(value).replaceAll("<", "\\u003c");
}

export function renderSeoHead(page: SeoPage, options: { noindex?: boolean } = {}): string {
  const pageUrl = canonicalUrl(page);
  const robots = options.noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large";

  return `<!-- SEO:START -->
    <title>${escapeHtml(page.title)}</title>
    <meta name="description" content="${escapeHtml(page.description)}" />
    <meta name="robots" content="${robots}" />
    <link rel="canonical" href="${pageUrl}" />
    <meta property="og:type" content="website" />
    <meta property="og:locale" content="sk_SK" />
    <meta property="og:site_name" content="${siteName}" />
    <meta property="og:title" content="${escapeHtml(page.title)}" />
    <meta property="og:description" content="${escapeHtml(page.description)}" />
    <meta property="og:url" content="${pageUrl}" />
    <meta property="og:image" content="${escapeHtml(socialImage)}" />
    <meta property="og:image:alt" content="Mechanik pri práci v autoservise IM Autotech v Trnave" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="${escapeHtml(page.title)}" />
    <meta name="twitter:description" content="${escapeHtml(page.description)}" />
    <meta name="twitter:image" content="${escapeHtml(socialImage)}" />
    <script id="structured-data" type="application/ld+json">${safeJson(structuredData(page))}</script>
    <!-- SEO:END -->`;
}

function upsertMeta(selector: string, attribute: "name" | "property", key: string, value: string): void {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.append(element);
  }
  element.content = value;
}

export function applySeoMetadata(page: SeoPage | undefined, notFound = false): void {
  if (!page || notFound) {
    document.title = "Stránka sa nenašla | IM Autotech";
    upsertMeta('meta[name="robots"]', "name", "robots", "noindex, nofollow");
    return;
  }

  const pageUrl = canonicalUrl(page);
  document.title = page.title;
  upsertMeta('meta[name="description"]', "name", "description", page.description);
  upsertMeta('meta[name="robots"]', "name", "robots", "index, follow, max-image-preview:large");
  upsertMeta('meta[property="og:title"]', "property", "og:title", page.title);
  upsertMeta('meta[property="og:description"]', "property", "og:description", page.description);
  upsertMeta('meta[property="og:url"]', "property", "og:url", pageUrl);
  upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", page.title);
  upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", page.description);

  let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.rel = "canonical";
    document.head.append(canonical);
  }
  canonical.href = pageUrl;

  let schema = document.head.querySelector<HTMLScriptElement>("#structured-data");
  if (!schema) {
    schema = document.createElement("script");
    schema.id = "structured-data";
    schema.type = "application/ld+json";
    document.head.append(schema);
  }
  schema.text = safeJson(structuredData(page));
}
